import React, { useCallback, useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiPower, FiX, FiShoppingBag } from 'react-icons/fi';
import { BiStore } from 'react-icons/bi';
import { MdArrowDropDown, MdArrowDropUp, MdQrCodeScanner } from 'react-icons/md';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { Badge, Collapse, Flex, Icon, useBreakpointValue } from '@chakra-ui/react';

import { useAuth } from '../../hooks/auth';
import { useCart } from '../../hooks/cart';
import InputSelectEmp from '../Inputs/Selects/InputSelectEmp';
import SearchBox from './SearchBox';
import IconSidebar from './IconSidebar';

import {
	TopNavbar,
	Profile,
	ItemMenu,
	ItemMenuCollapse,
	LinkItemMenuCollapse,
	SideBar
} from './styles';

type LojaData = {
  id: string;
  nome: string;
  url_avatar: string;
  url_page: string;
  fantazia: string;
  fone: string;
  endereco: {
    cep: string;
    uf: string;
    cid: string;
    cidcod: string;
    bai: string;
    endereco: string;
    num: string;
    comp: string;
    formatted_address: string;
    location: {
      lat: number;
      lng: number;
    };
  };
}

interface SidebarParams {
	isOpenCart?: (open: boolean) => void;
	handleSearchProduct?: (search: string) => void;
	setIsOpenScanner?: (open: boolean) => void;
	isOpenScanner?: boolean;
	isVisibleBtnScanner?: boolean;
	setIsOpenModalTrocaLoja?: (open: boolean) => void;
	setTrocaLoja?: (loja: LojaData) => void;
}

const Sidebar: React.FC<SidebarParams> = ({
	isOpenCart,
	handleSearchProduct,
	setIsOpenScanner,
	isOpenScanner,
	isVisibleBtnScanner,
	setIsOpenModalTrocaLoja,
	setTrocaLoja,
}) => {
	const isWideVersion = useBreakpointValue({
		base: false,
		md: true,
	});

  const location = useLocation();
  const { user, signOut, lojas, company, setCompany, refreshMenu, setMenuCollapse, menu } = useAuth();
	const { cart, addCartMerchant } = useCart();
  const formRef = useRef<FormHandles>(null);

  const [sidebar, setSidebar] = useState(false);

  useEffect(() => {
		refreshMenu();
  }, []);

  // const handleSignOut = useCallback(() => {
	async function handleSignOut() {
    const r = window.confirm('Deseja sair da sua conta?');

    if (r) signOut();
  }; // , [signOut]);

  function handleSubmit() {
    const loja = lojas.find(
      element =>
        element.id ===  formRef.current?.getFieldValue('loja'), // parseInt(formRef.current?.getFieldValue('loja')),
    );

		// Para verificar se o carrinho tem itens de outra loja antes de trocar a loja
		if (location.pathname === '/producao') {
			if (loja && cart && setTrocaLoja && setIsOpenModalTrocaLoja) {
				if (cart.items && cart.items?.length > 0) {
					setTrocaLoja(loja);
					setIsOpenModalTrocaLoja(true);
					return;
				}
			}

			loja && addCartMerchant(loja.id);
		};

		setCompany(loja as LojaData);
  };

  return (
    <>
			<TopNavbar sidebar={sidebar}>
				<div className="top-navbar">
					<div className="div-hamburger">
						<button className="hamburger" onClick={() => setSidebar(!sidebar)}>
							<FiMenu />
						</button>
					</div>

					<div className="top-nav-content">
						{location.pathname === '/producao' &&  (
							<>
								{isWideVersion && (
									<>
										<SearchBox handleSearchProduct={handleSearchProduct} />

										{isVisibleBtnScanner && (
											<Flex
												as="button"
												onClick={() => {
													setIsOpenScanner && setIsOpenScanner(!isOpenScanner);
													// history.push('/scan');
												}}
											>
												<Icon
													as={MdQrCodeScanner}
													mr={2}
													fontSize={28}
													color="#607d8b"
													_hover={{ color: "blue.500" }}
												/>
											</Flex>
										)}
									</>
								)}

								<Flex
									as="button"
									position="relative"
									marginRight={2}
									onClick={() => isOpenCart ? isOpenCart(true) : null}
									>
									<Icon
										as={FiShoppingBag}
										fontSize={26}
										color="#607d8b"
										_hover={{ color: "blue.500" }}
									/>

									{cart?.items && cart?.items?.length > 0 && (
										<Badge
											display="flex"
											alignItems="center"
											justifyContent="center"
											h={["21px", "21px"]}
											w={["21px", "21px"]}
											variant='solid'
											fontSize={['0.7rem', '0.7rem']}
											colorScheme='blue'
											borderRadius="50%"
											position="absolute"
											bottom="-5px"
											right="-6px"
											paddingTop={0.5}
											borderWidth={2}
											borderColor="#eceff1"
										>
											{cart?.items?.length}
										</Badge>
									)}
								</Flex>
							</>
						)}

						<Form ref={formRef} onSubmit={() => { }}>
							<InputSelectEmp
								id="loja"
								name="loja"
								placeholder="Empresa"
								options={lojas}
								icon={BiStore}
								value={company?.id}
								onChange={handleSubmit}
							/>
						</Form>

						<button className='btn-close' onClick={handleSignOut}>
							<FiPower />
						</button>
					</div>
				</div>

				{location.pathname === '/producao' && !isWideVersion && (
					<Flex
						alignItems="center"
						width="100%"
						paddingLeft={4}
						paddingBottom={2}
						zIndex={5}
					>
						<SearchBox handleSearchProduct={handleSearchProduct} />

						{isVisibleBtnScanner && (
							<Flex
								as="button"
								onClick={() => setIsOpenScanner && setIsOpenScanner(!isOpenScanner)}
							>
								<Icon
									as={MdQrCodeScanner}
									marginRight={4}
									marginLeft={2}
									fontSize={30}
									color="#607d8b"
									_hover={{ color: "blue.500" }}
								/>
							</Flex>
						)}
					</Flex>
				)}
			</TopNavbar>

			<SideBar sidebar={sidebar}>
				<ul className="nav-menu-items">
					<Profile sidebar={sidebar}>
						{user.avatar_url ? (
							<img src={user.avatar_url} alt="" />
						) : (
							<div className="avatar-name">{user.avatar_name}</div>
						)}

						<span>{user.user_name}</span>

						<button className="close" onClick={() => setSidebar(!sidebar)}>
							<FiX />
						</button>
					</Profile>

					<hr />

					{menu.map(item => {
						return (
							item.sub_menu ? (
								<ItemMenuCollapse className="nav-text-collapse" key={item.name}>
									<button className="btn-collapse" onClick={() => setMenuCollapse(item.name)}>
										<IconSidebar nameIcon={item.icon} />

										<span>
											{item.name}
											{item.collapse ? (
												<Icon as={MdArrowDropUp} fontSize="20" />
											) : (
												<Icon as={MdArrowDropDown} fontSize="20" />
											)}
										</span>
									</button>

									<Collapse in={item.collapse} animateOpacity>
										<Flex className="collapse" flexDir="column">
											{item.sub_menu.map(sub => {
												return (
													<LinkItemMenuCollapse
														key={sub.name}
														isPageSelected={location.pathname === sub.route ? true : false}
													>
														<Link to={sub.route}>
															<IconSidebar nameIcon={sub.icon} />

															<span>{sub.name}</span>
														</Link>
													</LinkItemMenuCollapse>
												)
											})}
										</Flex>
									</Collapse>
								</ItemMenuCollapse>
							) : (
									<ItemMenu
										key={item.name}
										className="nav-text"
										isPageSelected={location.pathname === item.route ? true : false}
									>
										<div>
											<Link to={item.route}>
												<IconSidebar nameIcon={item.icon} />

												<span>{item.name}</span>
											</Link>
										</div>
									</ItemMenu>
							)
						)
					})}
				</ul>
			</SideBar>
    </>
  );
};

export default Sidebar;


{/*
{/* DASHBOARD }
<ItemMenu
	className="nav-text"
	isPageSelected={location.pathname === '/dashboard' ? true : false}
>
	<div>
		<Link to="/dashboard">
			<MdDashboard />

			<span>Dashboard</span>
		</Link>
	</div>
</ItemMenu>

{/* PRODUÇÃO, FICHAS }
<ItemMenuCollapse className="nav-text-collapse">
	<button className="btn-collapse" onClick={() => setCollapseProducao(!collapseProducao)}>
		<Icon as={SiGitlfs} />
		<span>
			Produção
			{collapseProducao ? (
				<Icon as={MdArrowDropUp} fontSize="20" />
			) : (
				<Icon as={MdArrowDropDown} fontSize="20" />
			)}
		</span>
	</button>

	<Collapse in={collapseProducao} animateOpacity>
		<Flex className="collapse" flexDir="column">
			<LinkItemMenuCollapse
				to="/producao"
				isPageSelected={location.pathname === '/producao' ? true : false}
			>
				<FaBoxOpen />
				<span>Produzir</span>
			</LinkItemMenuCollapse>

			<LinkItemMenuCollapse
				to="/fichas"
				isPageSelected={location.pathname === '/fichas' ? true : false}
			>
				<MdListAlt />
				<span>Fichas</span>
			</LinkItemMenuCollapse>
		</Flex>
	</Collapse>
</ItemMenuCollapse>

{/* VENDAS }
<ItemMenu
	className="nav-text"
	isPageSelected={location.pathname === '/vendas' ? true : false}
>
	<div>
		<Link to="/vendas">
			<IoBagHandle />

			<span>Vendas</span>
		</Link>
	</div>
</ItemMenu>

{/* PRODUTOS  }
<ItemMenu
	className="nav-text"
	isPageSelected={location.pathname === '/produtos' ? true : false}
>
	<div>
		<Link to="/produtos">
			<FaBoxOpen />

			<span>Produtos</span>
		</Link>
	</div>
</ItemMenu>

{/* ÁREAS DE ENTREGA, ENTREGAS  }
<ItemMenuCollapse className="nav-text-collapse">
	<button className="btn-collapse" onClick={() => setCollapseEntrega(!collapseEntrega)}>
		<Icon as={MdMoped} />
		<span>
			Entrega
			{collapseEntrega ? (
				<Icon as={MdArrowDropUp} fontSize="20" />
			) : (
				<Icon as={MdArrowDropDown} fontSize="20" />
			)}
		</span>
	</button>

	<Collapse in={collapseEntrega} animateOpacity>
		<Flex className="collapse" flexDir="column">
			<LinkItemMenuCollapse
				to="/areaentrega"
				isPageSelected={location.pathname === '/areaentrega' ? true : false}
			>
				<MdMyLocation />
				<span>Áreas de Entrega</span>
			</LinkItemMenuCollapse>

			<LinkItemMenuCollapse
				to="/entregas"
				isPageSelected={location.pathname === '/entregas' ? true : false}
			>
				<MdMoped />
				<span>Entregas</span>
			</LinkItemMenuCollapse>
		</Flex>
	</Collapse>
</ItemMenuCollapse>

{/* CUPONS, CAMPANHAS }
<ItemMenuCollapse className="nav-text-collapse">
	<button className="btn-collapse" onClick={() => setCollapsePromocao(!collapsePromocao)}>
		<Icon as={FiTag} />
		<span>
			Promoção
			{collapsePromocao ? (
				<Icon as={MdArrowDropUp} fontSize="20" />
			) : (
				<Icon as={MdArrowDropDown} fontSize="20" />
			)}
		</span>
	</button>

	<Collapse in={collapsePromocao} animateOpacity>
		<Flex className="collapse" flexDir="column">
			<LinkItemMenuCollapse
				to="/cupom"
				isPageSelected={location.pathname === '/cupom' ? true : false}
			>
				<IoTicketSharp />
				<span>Cupons</span>
			</LinkItemMenuCollapse>

			<LinkItemMenuCollapse
				to="/campanha"
				isPageSelected={location.pathname === '/campanha' ? true : false}
			>
				<FaTags />
				<span>Campanhas</span>
			</LinkItemMenuCollapse>
		</Flex>
	</Collapse>
</ItemMenuCollapse>

{/* HORARIOS, PERFIL }
<ItemMenuCollapse className="nav-text-collapse">
	<button className="btn-collapse" onClick={() => setCollapseEmpresa(!collapseEmpresa)}>
		<Icon as={IoBusiness} />
		<span>
			Empresa
			{collapseEmpresa ? (
				<Icon as={MdArrowDropUp} fontSize="20" />
			) : (
				<Icon as={MdArrowDropDown} fontSize="20" />
			)}
		</span>
	</button>

	<Collapse in={collapseEmpresa} animateOpacity>
		<Flex className="collapse" flexDir="column">
			<LinkItemMenuCollapse
				to="/horarios"
				isPageSelected={location.pathname === '/horarios' ? true : false}
			>
				<FiClock />
				<span>Horários</span>
			</LinkItemMenuCollapse>

			<LinkItemMenuCollapse
				to="/perfil"
				isPageSelected={location.pathname === '/perfil' ? true : false}
			>
				<IoStorefront />
				<span>Perfil</span>
			</LinkItemMenuCollapse>
		</Flex>
	</Collapse>
</ItemMenuCollapse>
*/}
